import { render } from "./SurveyPage07.vue?vue&type=template&id=0ae1fc18&scoped=true"
const script = {}

import "./SurveyPage07.vue?vue&type=style&index=0&id=0ae1fc18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae1fc18"]])

export default __exports__